import { href } from "../App/href";
import { ConfirmDialog } from "../ConfirmDialog/ConfirmDialog";
import { database } from "../database/database";
import { useWarbandContext } from "./useWarbandContext";

export function DeleteWarband() {
  const warband = useWarbandContext();
  return (
    <ConfirmDialog
      heading="Delete warband?"
      description={`${warband.name} will be deleted. You cannot undo this.`}
      submitLabel="Delete"
      submitTheme="red"
      onSubmit={async () => {
        const { data } = warband;
        const result = await database.warbands.deleteOne(data);
        return result.mapSuccess(() => ({ navigateTo: href("~/builder") }));
      }}
    />
  );
}
